/**
 * The login view's english translations
 */
export const LOGIN_VIEW_EN = {
  login: 'Login',
  signIn: 'Enter newsrooms',
  email: 'E-Mail',
  enterEmail: 'E-Mail',
  password: 'Password',
  enterPassword: 'Password',
  noAccount: "You don't have a newsrooms account?",
  register: 'Start here.',
  privacy: 'Privacy Policy',
  tos: 'Terms of Service',
  imprint: 'Imprint',
  changePassword: 'Change Password',
  byUsing: 'By using newsrooms you agree to have read and understood our',
  and: 'and',
  newsrooms: 'newsrooms',
  freeTrialPeriod: 'Free Trial Period',
  freeTrialDescription:
    'Create a free Test Account with our standardised Communication Tasks in our hand-crafted newsrooms language styles.',
  orContactSales: 'or contact Sales for Enterprise Solution'
}
/**
 * The login view's german translation
 */
export const LOGIN_VIEW_DE = {
  login: 'Login',
  signIn: 'Newsrooms betreten',
  email: 'E-Mail',
  enterEmail: 'E-Mail',
  password: 'Passwort',
  enterPassword: 'Passwort',
  noAccount: 'Sie haben noch kein newsrooms-Konto?',
  register: 'Hier starten.',
  privacy: 'Datenschutzvereinbarung',
  tos: 'Nutzungsbedingungen',
  imprint: 'Impressum',
  changePassword: 'Passwort ändern',
  byUsing: 'Mit der Nutzung von newsrooms akzeptieren Sie unsere',
  and: 'und',
  newsrooms: 'newsrooms',
  freeTrialPeriod: 'Kostenlose Testphase',
  freeTrialDescription:
    'Erstellen Sie ein kostenloses Testkonto mit unseren standardisierten Kommunikationsaufgaben in unseren handgefertigten newsrooms-Sprachstilen.',
  orContactSales: 'oder kontaktieren Sie den Vertrieb für Unternehmenslösungen'
}
